module.exports = __webpack_public_path__ + "img/V26.3052aa8a.png";